import { Typography, Divider, ListItem } from "@mui/material";
import { GridEx } from "components/MuiExtras/Grid/GridEx";
import MuiContainer from "components/MuiExtras/MuiContainer";
import MuiLink from "components/MuiExtras/MuiLink";
import MuiMuted from "components/MuiExtras/Typography/MuiMuted";
import MuiReverse from "components/MuiExtras/Typography/MuiReverse";
import { PublicationTypeImage } from "components/PublicationTypeImage";
import AppResource from "components/Translations/AppResources";
import PublicationTypeName from "components/Translations/PublicationTypeName";
import UserFullProfileLink from "components/UserFullProfileLink";
import { Formaters } from "lib/Formarters";
import { PublicationType } from "models/ApiEnums";
import { GlobalSearchItem } from "models/ApiModels";
import * as React from "react";
import { getPublicationSecondViewAction } from "views/Timeline/Components/FeedHelpers";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    data: GlobalSearchItem;
    index: number;
    querySearch?: string;
    showDivider: boolean;
}

type Props = IProps;

/////////////////////////////////////////////////////////////////////////////////////////////////

export const SearchRenderPublication: React.FC<Props> = (props) => {

    const { data, index, showDivider } = props;

    const onClick = getPublicationSecondViewAction(data.publicationType, data.id, data.parentId, props.querySearch, data.title);

    return (
        <React.Fragment key={"seachItem-" + index}>
            <ListItem button onClick={onClick}>
                <MuiContainer margin="dense" >
                    <GridEx container wrap="nowrap" spacing={1}>
                        <GridEx item>
                            <MuiLink underline="none" onClick={onClick}>
                                {
                                    data.thumbnailUrl
                                        ? <img src={data.thumbnailUrl} alt={data.title} width={48} height={48} />
                                        : <PublicationTypeImage publicationType={data.publicationType} width="48" />
                                }
                            </MuiLink>
                        </GridEx>
                        <GridEx item xs>
                            <div>
                                <Typography color="secondary" variant="body1">
                                    {data.title}
                                </Typography>
                            </div>
                            <MuiMuted>
                                <Typography variant="caption">
                                    <b><PublicationTypeName publicationType={data.publicationType} /></b>
                                    <span>&nbsp;<AppResource resource="Common.Literals.WrittenBy" parameters="lowercase" />&nbsp;<UserFullProfileLink user={{ userId: data.authorId, name: data.authorName }} /></span>
                                    <span>&nbsp;{Formaters.relativeTime(data.lastUpdateDate)}</span>
                                </Typography>
                            </MuiMuted>
                        </GridEx>
                    </GridEx>
                </MuiContainer>
            </ListItem>
            {showDivider && <Divider />}
        </React.Fragment>
    );
};